import { useParams } from "react-router-dom";
import Categories from "./Categories";
import Products from "./Products";
import Comments from "./Comments";

export default function CatalogOutlet() {
  const { subMenu } = useParams();

  switch (subMenu) {
    case "products":
      return <Products />;
    case "comments":
      return <Comments />;
    case "categories":
      return <Categories />;
    default:
      return <Categories />;
  }
}
